import { Exercise as ComponentExercise, ExerciseType, FillInBlanksData } from "@/services/admin/exercises.interfaces";
import { EditorInterface } from "./EditorInterface";
import { FormInput } from "lucide-react";

/**
 * Editor para exercícios de preencher lacunas (versão unificada)
 * Combina as funcionalidades duplicadas das implementações anteriores
 */
export class FillInTheBlanksInfo extends EditorInterface {
  /**
   * Retorna as informações para exibir no cartão do exercício
   * @param exercise Objeto do exercício
   */
  static GetCardInfo(exercise: ComponentExercise): {
    title: string;
    subtitle: string;
    description?: string;
  } {
    if (!exercise || (exercise.type !== ExerciseType.FillInTheBlanks && !FillInTheBlanksInfo.SupportsExerciseType(exercise.type as unknown as string))) {
      return {
        title: 'Preencher Lacunas',
        subtitle: 'Sem detalhes',
      };
    }

    try {
      // Tenta extrair os dados do exercício, lidando com diferentes formatos
      let text = 'Sem texto';
      let blanks: string[] = [];
      
      // Se os dados estiverem no formato aninhado (data é um objeto)
      if (exercise.data && typeof exercise.data === 'object') {
        const data = exercise.data as unknown as FillInBlanksData;
        text = data.text || 'Sem texto';
        blanks = data.blanks || [];
      } 
      // Se os dados estiverem no formato plano
      else if ('text' in exercise) {
        text = (exercise as any).text || 'Sem texto';
        blanks = (exercise as any).blanks || [];
      }
      
      // Conta o número de lacunas
      const blanksCount = blanks.length;
      
      return {
        title: "Preencher Lacunas",
        subtitle: text.length > 60 ? `${text.substring(0, 60)}...` : text,
        description: blanksCount > 0 ? `${blanksCount} lacunas` : "Sem lacunas definidas",
      };
    } catch (error) {
      console.error("Erro ao processar dados do exercício de preencher lacunas:", error);
      return {
        title: 'Preencher Lacunas',
        subtitle: 'Erro ao processar dados',
      };
    }
  }
  
  /**
   * Retorna o título do tipo de exercício
   */
  static getTitle(): string {
    return "Preencher Lacunas";
  }
  
  /**
   * Retorna uma descrição formatada para o exercício
   * @param exercise Objeto do exercício
   */
  static getDescription(exercise: ComponentExercise): string {
    if (!exercise) {
      return "Sem detalhes";
    }
    
    try {
      // Tenta extrair as lacunas do exercício, lidando com diferentes formatos
      let blanks: string[] = [];
      
      // Se os dados estiverem no formato aninhado (data é um objeto)
      if (exercise.data && typeof exercise.data === 'object') {
        const data = exercise.data as unknown as FillInBlanksData;
        blanks = data.blanks || [];
      } 
      // Se os dados estiverem no formato plano
      else if ('blanks' in exercise) {
        blanks = (exercise as any).blanks || [];
      }
      
      const blanksCount = blanks.length;
      return blanksCount > 0 ? `${blanksCount} lacunas` : "Sem lacunas definidas";
    } catch (error) {
      console.error("Erro ao processar dados do exercício:", error);
      return "Erro ao processar dados";
    }
  }
  
  /**
   * Retorna o ícone para o tipo de exercício
   */
  static getIcon() {
    return FormInput;
  }
  
  /**
   * Verifica se o exercício é do tipo Preencher Lacunas
   */
  static SupportsExerciseType(type: string): boolean {
    return type === ExerciseType.FillInTheBlanks;
  }
}